import './css/readmore.css'
import { useState } from 'react'

type ReadMoreProperties = {
    children?: JSX.Element;
    expanded?: boolean;
}


export default function ReadMoreComponent(props: ReadMoreProperties) {
    const [isExpanded, setIsExpanded] = useState(props.expanded || false);
    const [isChanged, setIsChanged] = useState(false);


    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
        setIsChanged(true);
    };
    const readMoreText = isExpanded ? 'Read less' : 'Read more';
    const readMoreClass = isChanged ? (isExpanded ? 'readmore_expanded_animation' : 'readmore_collapsed_animation') : (isExpanded ? 'readmore_expanded' : 'readmore_collapsed');
    return (
        <div className="readmore_box">
            <div className={`readmore_content ${readMoreClass}`}>{props.children}</div>
            <div className="readmore_button"><button onClick={toggleExpand}>{readMoreText}</button></div>
        </div>
    )
}